import { Stack, InputLabel, FormControlLabel, Checkbox, SxProps, Theme } from '@mui/material'

interface CheckboxGroupProps<T> {
  label: string
  items: T[]
  getKey: (item: T) => string | number
  getLabel: (item: T) => string
  isChecked: (item: T) => boolean
  onChange: (item: T) => void
  sx?: SxProps<Theme>
  disabled?: boolean
}

function CheckboxGroup<T>({
  label,
  items,
  getKey,
  getLabel,
  isChecked,
  onChange,
  sx,
  disabled = false
}: CheckboxGroupProps<T>) {
  return (
    <Stack sx={{ width: '100%', ...sx }}>
      <InputLabel>{label}</InputLabel>
      {items.map((item, i) => (
        <FormControlLabel
          key={`${getKey(item)}-${i}`}
          control={<Checkbox disabled={disabled} checked={isChecked(item)} onChange={() => onChange(item)} />}
          label={getLabel(item)}
        />
      ))}
    </Stack>
  )
}

export default CheckboxGroup
